import {Injectable} from '@angular/core';
import {AngularFirestore, AngularFirestoreDocument} from '@angular/fire/compat/firestore';
import {AngularFireStorage, AngularFireUploadTask, AngularFireStorageReference} from '@angular/fire/compat/storage';
import {AngularFireFunctions} from '@angular/fire/compat/functions';
import {Observable} from 'rxjs';
import {SnackBarIconService} from '../shared/snack-bar-icon/snack-bar-icon.service';
import {MatTableDataSource } from '@angular/material/table';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import {Product, ProductItem} from '../models/product';
import {Event} from '../models/event';
import {finalize} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ProductService {

  public isEdit: boolean = false;
  public localTitle: string;
  public spinner: boolean = false;

  public currentProduct: Product;

  public productDataSource: MatTableDataSource<any>;
  public productDataSourceHistory: MatTableDataSource<any>;

  public productItensDataSource: MatTableDataSource<any>;
  public productPricesDataSource: MatTableDataSource<any>;

  public productRequirementsDataSource: MatTableDataSource<any>;

  public arrayEvents: any[];

  public objectImage: any = null;
  public storedImage: any;

  public objectImage_en: any = null;
  public storedImage_en: any;

  public objectButton: any = null;
  public storedButton: any;

  public objectButton_en: any = null;
  public storedButton_en: any;

  //public objectWaiting: any = null;
  //public storedWaiting: any;

  private itemDoc: AngularFirestoreDocument<Product>;
  private item: Observable<Product>;

  constructor (
    private fb: FormBuilder,
    private db: AngularFirestore,
    private fs: AngularFireStorage,
    private ff: AngularFireFunctions,
    private snackBar: SnackBarIconService) { }

  setEdit (): any {
    if (this.currentProduct.id) {
      this.isEdit = true
      this.localTitle = this.currentProduct.name
    } else {
      this.isEdit = false;
      this.localTitle = "Novo Produto"
    }
  }

  //  @ViewChild(MatSort, {static: false}) sort: MatSort;

  selectProducts () {
    return this.db.collection<Product>('sbccv_products', ref => ref
      .where('deleted', '==', false)
      .orderBy('name', 'asc')).snapshotChanges()
  }

  selectAllProductsNoAnnuities () {
    return this.db.collection<Product>('sbccv_products', ref => ref
      //.where('deleted', '==', false)
      .where('part_of', '<', 3)
      .orderBy('part_of', 'asc')
      .orderBy('name', 'asc')).snapshotChanges()
  }

  selectAllProducts () {
    return this.db.collection<Product>('sbccv_products', ref => ref
      //.where('deleted', '==', false)
      .where('part_of', '<', 3)
      .orderBy('part_of', 'asc')
      .orderBy('name', 'asc')).snapshotChanges()
  }

  loadProducts (_sort, _sortHistory) {

    return this.db.collection<Product>('sbccv_products', ref => ref
      // .where('deleted', '==', false)
      // .orderBy('name', 'asc')).snapshotChanges()
      .orderBy('created', 'desc')).snapshotChanges()
      .subscribe((result) => {

        let arrayProducts: Product[] = []
        let arrayProductsHistory: Product[] = []

        result.forEach((item) => {

          if (item.payload.doc.data().part_of != 3) {

            let product = new Product();
            product.id = item.payload.doc.id;
            product.name = item.payload.doc.data().name;
            product.text = item.payload.doc.data().text;
            product.image = item.payload.doc.data().image;
            product.button = item.payload.doc.data().button;

            product.name_en = item.payload.doc.data().name_en;
            product.text_en = item.payload.doc.data().text_en;
            product.image_en = item.payload.doc.data().image_en;
            product.button_en = item.payload.doc.data().button_en;
            product.image_waiting = item.payload.doc.data().image_waiting;

            product.active = item.payload.doc.data().active;
            product.requirements = item.payload.doc.data().requirements;

            product.discount_percent = item.payload.doc.data().discount_percent;
            product.discount_product_id = item.payload.doc.data().discount_product_id;

            product.available = item.payload.doc.data().available;
            product.available_purchase = item.payload.doc.data().available_purchase;
            product.available_schedule = item.payload.doc.data().available_schedule;
            product.part_of = item.payload.doc.data().part_of;
            product.limit_per_member = item.payload.doc.data().limit_per_member;

            product.isAnnuity = item.payload.doc.data().isAnnuity;
            product.onlyForVaccinated = item.payload.doc.data().onlyForVaccinated || false;

            product.created = item.payload.doc.data().created;

            product.deleted = item.payload.doc.data().deleted ? true : false

            product.sponsors = item.payload.doc.data().sponsors;
            product.sponsors_url = item.payload.doc.data().sponsors_url;

            product.url_schedule = item.payload.doc.data().url_schedule ? item.payload.doc.data().url_schedule : '';

            if (product.deleted) {
              arrayProductsHistory.push(product)
            } else {
              arrayProducts.push(product)
            }
          }
        })

        this.productDataSource = new MatTableDataSource(arrayProducts);
        this.productDataSource.sort = _sort;

        this.productDataSourceHistory = new MatTableDataSource(arrayProductsHistory);
        this.productDataSourceHistory.sort = _sortHistory;

      })
    /*,
      (error) => {
        console.log(JSON.stringify(error))
        this.snackBar.openSnackBar("Acesso negado", '', 'error');
      })
      */
  }

  selectById (id) {
    this.itemDoc = this.db.doc<Product>('sbccv_products/' + id);
    this.item = this.itemDoc.valueChanges();
    return this.item;
  }

  getById (id) {
    return this.db.doc<Product>('sbccv_products/' + id)
      .get();
  }

  insert (product) {
    this.spinner = true;

    const entity = this.createProduct(product)

    return this.db.collection('sbccv_products').add(Object.assign({}, entity))
      .then((result) => {
        entity.id = result.id
        this.currentProduct = entity;
        this.isEdit = true;
      })
      .catch((error) => {
        console.log("insert product error: " + error)
        let msgError: string = this.makeMsgError(error.details.code)
        this.snackBar.openSnackBar(msgError, '', 'error');
      })
      .finally(() => {
        this.spinner = false
      });
  }

  update (product: Product) {

    this.spinner = true;
    const entity = this.createProduct(product)
    // console.log("update product: " + JSON.stringify(entity))

    return this.db.collection('sbccv_products').doc(product.id).set(Object.assign({}, entity), {merge: true})
      .then(() => {

        if (this.objectImage) {
          this.uploadImage(this.objectImage, product.id)
        } else {
          this.snackBar.openSnackBar("Sucesso!", '', 'success');
        }

        if (this.objectImage_en) {
          this.uploadImage_en(this.objectImage_en, product.id)
        } else {
          this.snackBar.openSnackBar("Sucesso!", '', 'success');
        }

        if (this.objectButton) {
          this.uploadImageButton(this.objectButton, product.id)
        } else {
          this.snackBar.openSnackBar("Sucesso!", '', 'success');
        }

        if (this.objectButton_en) {
          this.uploadImageButton_en(this.objectButton_en, product.id)
        } else {
          this.snackBar.openSnackBar("Sucesso!", '', 'success');
        }

        /*
        if (this.objectWaiting) {
          this.uploadImageWaiting(this.objectWaiting, product.id)
        } else {
          this.snackBar.openSnackBar("Sucesso!", '', 'success');
        }
        */

      })
      .catch((error) => {
        console.log("product update error: " + JSON.stringify(error))
        let msgError: string = this.makeMsgError(error.details.code)
        this.snackBar.openSnackBar(msgError, '', 'error');
      })
      .finally(() => {
        this.spinner = false
      });

  }

  updateChecks (product_id: string, config: any) {

    this.spinner = true;

    console.log('config: ' + JSON.stringify(config))

    return this.db.collection('sbccv_products').doc(product_id).set(config, {merge: true})
      .then(() => {
        this.snackBar.openSnackBar("Sucesso!", '', 'success');
      })
      .catch((error) => {
        console.log("product update checks error: " + JSON.stringify(error))
        let msgError: string = this.makeMsgError(error.details.code)
        this.snackBar.openSnackBar(msgError, '', 'error');
      })
      .finally(() => {
        this.spinner = false
      });

  }

  delete (entity_id: any, flag: boolean) {
    //na real é um update
    return this.db.collection('sbccv_products').doc(entity_id)
      .set({'deleted': flag}, {merge: true})
      .then(() => {
        this.snackBar.openSnackBar("Sucesso!", '', 'success');
      })
      .catch((error) => {
        console.log("product deleted error: " + JSON.stringify(error))
        let msgError: string = this.makeMsgError(error.details.code)
        this.snackBar.openSnackBar(msgError, '', 'error');
      })
      .finally(() => {
        this.spinner = false
      });
  }

  createProduct (data: any): Product {

    //  console.log("requirements: " + JSON.stringify(this.currentProduct.requirements))

    let product = new Product()

    product.requirements = this.currentProduct.requirements ? this.currentProduct.requirements : [];

    product.name = data.name;
    product.text = data.text ? data.text : "";
    product.active = data.active ? data.active : "";

    product.name_en = data.name_en ? data.name_en : "";
    product.text_en = data.text_en ? data.text_en : "";

    product.discount_percent = data.discount_percent ? data.discount_percent : 0;
    product.discount_product_id = data.discount_product_id ? data.discount_product_id : "";

    product.available = data.available ? data.available : false;
    product.available_purchase = data.available_purchase ? data.available_purchase : false;
    product.available_schedule = data.available_schedule ? data.available_schedule : false;
    product.part_of = data.part_of ? data.part_of : 0;

    product.limit_per_member = data.limit_per_member ? data.limit_per_member : 0;

    product.isAnnuity = data.isAnnuity ? data.isAnnuity : false;

    product.onlyForVaccinated = data.onlyForVaccinated ? true : false;

    if (!this.isEdit)
      product.created = new Date();
    else
      product.created = data.created ? new Date(data.created.seconds * 1000) : new Date()

    /*
  if (data.image)
    product.image = data.image
  else
    product.image = '';

  if (data.image_en)
    product.image_en = data.image_en
  else
    product.image_en = '';
    */


    product.deleted = data.deleted ? data.deleted : false;

    product.sponsors_url = data.sponsors_url ? data.sponsors_url : '';

    product.url_schedule = data.url_schedule ? data.url_schedule : '';

    return product;
  }

  createForm (data) {
    let form: FormGroup = this.fb.group({
      id: new FormControl(''),
      name: new FormControl('', [ Validators.required ]),
      text: new FormControl(''),

      image: new FormControl(''),
      image_button: new FormControl(''),

      name_en: new FormControl('', [ Validators.required ]),
      text_en: new FormControl(''),

      image_en: new FormControl(''),
      image_button_en: new FormControl(''),

      image_waiting: new FormControl(''),

      discount_percent: new FormControl(''),
      discount_product_id: new FormControl(''),

      active: new FormControl(''),

      isAnnuity: new FormControl(''),
      onlyForVaccinated: new FormControl(''),

      available: new FormControl(''),
      available_purchase: new FormControl(''),
      available_schedule: new FormControl(''),
      part_of: new FormControl(''),

      limit_per_member: new FormControl(''),

      created: new FormControl(''),

      sponsors_url: new FormControl(''),
      url_schedule: new FormControl(''),

      deleted: new FormControl('')

    });

    if (data) {
      form.controls.id.setValue(data.id);
      form.controls.active.setValue(data.active);

      form.controls.name.setValue(data.name);
      form.controls.text.setValue(data.text || "");
      form.controls.image.setValue(data.image);
      form.controls.image_button.setValue(data.button);

      form.controls.name_en.setValue(data.name_en);
      form.controls.text_en.setValue(data.text_en || "");
      form.controls.image_en.setValue(data.image_en);
      form.controls.image_button_en.setValue(data.button_en);
      form.controls.image_waiting.setValue(data.image_waiting);

      form.controls.discount_percent.setValue(data.discount_percent);
      form.controls.discount_product_id.setValue(data.discount_product_id);

      form.controls.available.setValue(data.available);
      form.controls.available_purchase.setValue(data.available_purchase);
      form.controls.available_schedule.setValue(data.available_schedule);
      form.controls.part_of.setValue(data.part_of);
      form.controls.isAnnuity.setValue(data.isAnnuity);
      form.controls.onlyForVaccinated.setValue(data.onlyForVaccinated);
      form.controls.limit_per_member.setValue(data.limit_per_member);
      form.controls.created.setValue(data.created);
      form.controls.sponsors_url.setValue(data.sponsors_url);
      form.controls.url_schedule.setValue(data.url_schedule);

      form.controls.deleted.setValue(data.deleted);
    }

    return form
  }

  createItemForm () {
    let form: FormGroup = this.fb.group({
      id: new FormControl(''),
      product_id: new FormControl('', [ Validators.required ]),
      event_id: new FormControl('', [ Validators.required ]),
      event_name: new FormControl('', [ Validators.required ])
    });

    return form
  }

  createPriceForm () {
    let form: FormGroup = this.fb.group({
      id: new FormControl(''),
      product_id: new FormControl('', [ Validators.required ]),
      category_id: new FormControl('', [ Validators.required ]),
      category_name: new FormControl('', [ Validators.required ]),
      value: new FormControl('', [ Validators.required ]),
      date_until: new FormControl('', [ Validators.required ])
    });

    return form
  }

  loadEvents () {
    return this.db.collection<Event>('sbccv_events', ref => ref
      .where('deleted', '==', false)
      .orderBy('name')).snapshotChanges()
      .subscribe((result) => {
        this.arrayEvents = result.map(item => {
          let event = new Event();
          event.id = item.payload.doc.id;
          event.name = item.payload.doc.data().name;
          event.text = item.payload.doc.data().text;
          return event;
        });
      },
        (error) => {
          console.log(JSON.stringify(error))
          this.snackBar.openSnackBar("load event error", '', 'error');
        })
  }

  loadEventsForProducts () {
    return this.db.collection<Event>('sbccv_events', ref => ref
      .where('deleted', '==', false)
      .orderBy('name')).snapshotChanges()
      .subscribe((result) => {
        
        this.arrayEvents = [];
        result.forEach((item)=>{
          const isAnnuity: boolean = item.payload.doc.data().annuity ? true : false;
          if (!isAnnuity) {
            let event = new Event();
            event.id = item.payload.doc.id;
            event.name = item.payload.doc.data().name;
            event.text = item.payload.doc.data().text;
            this.arrayEvents.push(event)
          }
        })
      },
        (error) => {
          console.log(JSON.stringify(error))
          this.snackBar.openSnackBar("load event error", '', 'error');
        })
  }

  loadProductItens (id) {
    return this.db.collection<ProductItem>('sbccv_product_itens', ref => ref
      .where('product_id', '==', id)).snapshotChanges()
      .subscribe((result) => {
        let array = result.map(item => {
          let product = new ProductItem();
          product.id = item.payload.doc.id;
          product.product_id = item.payload.doc.data().product_id;
          product.event_id = item.payload.doc.data().event_id;
          product.event_name = item.payload.doc.data().event_name;
          return product;
        });

        this.productItensDataSource = new MatTableDataSource(array);
        //  this.productItensDataSource.paginator = this.paginator;
      },
        (error) => {
          console.log(JSON.stringify(error))
          this.snackBar.openSnackBar("Load ProductItens error", '', 'error');
        })
  }

  loadProductItensByEvent (id) {
    return this.db.collection<ProductItem>('sbccv_product_itens', ref => ref
      .where('event_id', '==', id)).snapshotChanges()
  }


  loadProductItensByProduct (id) {
    return this.db.collection<ProductItem>('sbccv_product_itens', ref => ref
      .where('product_id', '==', id)).snapshotChanges()
  }

  breadCrumb (value) {

    if (value) {
      if (value.length > 50) {
        return value.substr(0, 50) + " ..."
      } else {
        return value
      }
    } else {
      return "Novo Produto"
    }

  }

  makeMsgError (errorsCode) {
    let msgError: string

    switch (errorsCode) {
      case "auth/email-already-exists":
        msgError = "Este email já está em uso"
        break;
    }

    return msgError
  }



  addPrice (productPrice) {
    this.spinner = true;

    return this.db.collection('sbccv_product_prices').add(Object.assign({}, productPrice))
      .then((result) => {
        this.snackBar.openSnackBar("Sucesso!", '', 'success');
      })
      .catch((error) => {
        console.log("insert product price error: " + error)
        let msgError: string = this.makeMsgError(error.details.code)
        this.snackBar.openSnackBar(msgError, '', 'error');
      })
      .finally(() => {
        this.spinner = false
      });
  }

  deletePrice (id: any) {
    this.spinner = true;
    return this.db.collection('sbccv_product_prices').doc(id).delete()
      .then((e) => {
        this.snackBar.openSnackBar("Sucesso!", '', 'success');
      })
      .catch((error) => {
        console.log("delete price error" + error)
        this.snackBar.openSnackBar("Erro ao apagar preço", '', 'error');
      })
      .finally(() => {
        this.spinner = false;
      })
  }

  deleteItem (id: any) {
    this.spinner = true;
    return this.db.collection('sbccv_product_itens').doc(id).delete()
      .then((e) => {
        this.snackBar.openSnackBar("Sucesso!", '', 'success');
      })
      .catch((error) => {
        console.log("delete item error" + error)
        this.snackBar.openSnackBar("Erro ao apagar event item", '', 'error');
      })
      .finally(() => {
        this.spinner = false;
      })
  }

  addItem (productItem) {
    this.spinner = true;

    return this.db.collection('sbccv_product_itens').add(Object.assign({}, productItem))
      .then((result) => {
        this.snackBar.openSnackBar("Sucesso!", '', 'success');

        let data = this.productItensDataSource.data;
        this.productItensDataSource.data = data;

      })
      .catch((error) => {
        console.log("insert product item error: " + error)
        let msgError: string = this.makeMsgError(error.details.code)
        this.snackBar.openSnackBar(msgError, '', 'error');
      })
      .finally(() => {
        this.spinner = false
      });
  }

  previewImage (event) {

    if (event.target.files.length === 0)
      return;

    var mimeType = event.target.files[ 0 ].type;
    if (mimeType.match(/image\/*/) == null) {
      this.snackBar.openSnackBar("Apenas arquivos .png", '', 'info');
      return;
    }

    var reader = new FileReader();
    this.objectImage = event.target.files[ 0 ];
    reader.readAsDataURL(event.target.files[ 0 ]);
    reader.onload = (_event) => {
      this.storedImage = reader.result;
      return event.target.files[ 0 ];
    }
  }

  uploadImage (file, product_id) {

    const fsRef: AngularFireStorageReference = this.fs.ref("images/products/" + product_id + ".png");
    const fsTask: AngularFireUploadTask = fsRef.put(file);

    fsTask.snapshotChanges().pipe(
      finalize(() => {
        fsRef.getDownloadURL().subscribe(url => {
          this.updateImage(product_id, url)
        });
      }))
      .subscribe();
  }

  updateImage (product_id: any, image: any) {
    return this.db.collection('sbccv_products').doc(product_id).set({image: image}, {merge: true})
      .then(() => {
        this.objectImage = ""
        this.snackBar.openSnackBar("Sucesso!", '', 'success');
      })
      .catch((err) => {
        console.log("erro upadate image: " + JSON.stringify(err))
      })
  }

  previewImageButton (event) {

    if (event.target.files.length === 0)
      return;

    var mimeType = event.target.files[ 0 ].type;
    if (mimeType.match(/image\/*/) == null) {
      this.snackBar.openSnackBar("Apenas arquivos .png", '', 'info');
      return;
    }

    var reader = new FileReader();
    this.objectButton = event.target.files[ 0 ];
    reader.readAsDataURL(event.target.files[ 0 ]);
    reader.onload = (_event) => {
      this.storedButton = reader.result;
      return event.target.files[ 0 ];
    }
  }

  uploadImageButton (file, product_id) {
    const fsRef: AngularFireStorageReference = this.fs.ref("images/products/" + product_id + "_button.png");
    const fsTask: AngularFireUploadTask = fsRef.put(file);

    fsTask.snapshotChanges().pipe(
      finalize(() => {
        fsRef.getDownloadURL().subscribe(url => {
          this.updateImageButton(product_id, url)
        });
      }))
      .subscribe();
  }

  updateImageButton (product_id: any, image: any) {
    return this.db.collection('sbccv_products').doc(product_id).set({button: image}, {merge: true})
      .then(() => {
        this.objectButton = ""
        this.snackBar.openSnackBar("Sucesso!", '', 'success');
      })
      .catch((err) => {
        console.log("erro upadate image: " + JSON.stringify(err))
      })
  }

  previewImage_en (event) {

    if (event.target.files.length === 0)
      return;

    var mimeType = event.target.files[ 0 ].type;
    if (mimeType.match(/image\/*/) == null) {
      this.snackBar.openSnackBar("Apenas arquivos .png", '', 'info');
      return;
    }

    var reader = new FileReader();
    this.objectImage_en = event.target.files[ 0 ];
    reader.readAsDataURL(event.target.files[ 0 ]);
    reader.onload = (_event) => {
      this.storedImage_en = reader.result;
      return event.target.files[ 0 ];
    }
  }

  uploadImage_en (file, product_id) {
    const fsRef: AngularFireStorageReference = this.fs.ref("images/products/" + product_id + "_en.png");
    const fsTask: AngularFireUploadTask = fsRef.put(file);

    fsTask.snapshotChanges().pipe(
      finalize(() => {
        fsRef.getDownloadURL().subscribe(url => {
          this.updateImage_en(product_id, url)
        });
      }))
      .subscribe();
  }

  updateImage_en (product_id: any, image: any) {
    return this.db.collection('sbccv_products').doc(product_id).set({image_en: image}, {merge: true})
      .then(() => {
        this.objectImage_en = ""
        this.snackBar.openSnackBar("Sucesso!", '', 'success');
      })
      .catch((err) => {
        console.log("erro upadate image: " + JSON.stringify(err))
      })
  }

  previewImageButton_en (event) {

    if (event.target.files.length === 0)
      return;

    var mimeType = event.target.files[ 0 ].type;
    if (mimeType.match(/image\/*/) == null) {
      this.snackBar.openSnackBar("Apenas arquivos .png", '', 'info');
      return;
    }

    var reader = new FileReader();
    this.objectButton_en = event.target.files[ 0 ];
    reader.readAsDataURL(event.target.files[ 0 ]);
    reader.onload = (_event) => {
      this.storedButton_en = reader.result;
      return event.target.files[ 0 ];
    }
  }

  uploadImageButton_en (file, product_id) {
    const fsRef: AngularFireStorageReference = this.fs.ref("images/products/" + product_id + "_button_en.png");
    const fsTask: AngularFireUploadTask = fsRef.put(file);

    fsTask.snapshotChanges().pipe(
      finalize(() => {
        fsRef.getDownloadURL().subscribe(url => {
          this.updateImageButton_en(product_id, url)
        });
      }))
      .subscribe();
  }

  updateImageButton_en (product_id: any, image: any) {
    return this.db.collection('sbccv_products').doc(product_id).set({button_en: image}, {merge: true})
      .then(() => {
        this.objectButton_en = ""
        this.snackBar.openSnackBar("Sucesso!", '', 'success');
      })
      .catch((err) => {
        console.log("erro upadate image: " + JSON.stringify(err))
      })
  }

  /*
  previewImageWaiting (event) {

    if (event.target.files.length === 0)
      return;

    var mimeType = event.target.files[ 0 ].type;


    var reader = new FileReader();
    this.objectWaiting = event.target.files[ 0 ];
    reader.readAsDataURL(event.target.files[ 0 ]);
    reader.onload = (_event) => {
      this.storedWaiting = reader.result;
      return event.target.files[ 0 ];
    }
  }

  uploadImageWaiting (file, product_id) {
    const fsRef: AngularFireStorageReference = this.fs.ref("images/products/" + product_id + "_waiting.png");
    const fsTask: AngularFireUploadTask = fsRef.put(file);

    fsTask.snapshotChanges().pipe(
      finalize(() => {
        fsRef.getDownloadURL().subscribe(url => {
          this.updateImageWaiting(product_id, url)
        });
      }))
      .subscribe();
  }

  updateImageWaiting (product_id: any, image: any) {
    return this.db.collection('sbccv_products').doc(product_id).set({image_waiting: image}, {merge: true})
      .then(() => {
        this.objectWaiting = ""
        this.snackBar.openSnackBar("Sucesso!", '', 'success');
      })
      .catch((err) => {
        console.log("erro upadate image: " + JSON.stringify(err))
      })
  }
  */

  addRequirement (requiedProduct: any) {

    if (!this.currentProduct.requirements)
      this.currentProduct.requirements = []

    this.currentProduct.requirements.push({
      "product_id": requiedProduct.id,
      "product_name": requiedProduct.name
    })

    this.updateRequirements(this.currentProduct)
  }

  removeRequirement (id) {

    this.currentProduct.requirements = this.currentProduct.requirements.filter((e) => {
      return e.id != id
    })

    this.updateRequirements(this.currentProduct)
  }

  updateRequirements (currentProduct) {

    this.db.collection('sbccv_products').doc(currentProduct.id)
      .set({"requirements": currentProduct.requirements}, {merge: true})
      .then(() => {

        this.productRequirementsDataSource = new MatTableDataSource(this.currentProduct.requirements);

        this.snackBar.openSnackBar("Sucesso!", '', 'success');
      })
      .catch((error) => {
        this.snackBar.openSnackBar("Erro!", '', 'error');
      })


  }


  updateBannerSponsor (product_id, banners) {

    return this.db.collection('sbccv_products').doc(product_id).set(Object.assign({}, {'sponsors': banners}), {merge: true})
      .then(() => {
        this.snackBar.openSnackBar("Sucesso!", '', 'success');
      })
      .catch((error) => {
        console.log("product update banner error: " + JSON.stringify(error))
        this.snackBar.openSnackBar("Erro", '', 'error');
      })

  }

  /*
  getAnnuities() {
    
    return this.db.collection<Product>('sbccv_products', ref => ref
    .where('deleted', '==', false)
    .where('isAnnuity', '==', true)
    .orderBy('name', 'asc')).snapshotChanges()
    .subscribe((result) => {
      result.forEach((item)=>{
        console.log("item.id: " + item.payload.doc.id)
        return this.db.collection<Product>('sbccv_product_itens', ref => ref
        .where('product_id', '==', item.payload.doc.id))
        .snapshotChanges()
        

      })
    })

  }
  */
}